module.exports = __webpack_public_path__ + "img/preview-2.04b77b58.png";